<template>
  <b-card class="triangle-card__background">
    <div class="triangle-card__title">{{ $t(getTitle(type)) }}</div>
    <b-row class="text-center">
      <b-col>
        <polygonal-chart
          :value="xy"
          :type="type"
          :reference-coordinates="referenceCoordinates"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import PolygonalChart from '@/domain/components/installation/engineering/chromatography/polygonalChart';

export default {
  components: {
    PolygonalChart,
  },
  props: {
    coordinates: Array,
    type: String,
    referenceCoordinates: Array,
  },
  computed: {
    xy() {
      return this.coordinates;
    },
  },
  methods: {
    getTitle(triangle) {
      const title = {
        'duval-triangle-1': 'enums.engineering.chromatography.methods.duval.triangle-1',
        'duval-triangle-4': 'enums.engineering.chromatography.methods.duval.triangle-4',
        'duval-triangle-5': 'enums.engineering.chromatography.methods.duval.triangle-5',
      };
      return title[triangle];
    },
  },
};
</script>

<style lang="sass" scoped>
  .triangle-card
    &__background
      background: var(--color-background-dark)
    &__title
      font-size: 1.1rem
      color: var(--color-primary)
      font-weight: bold
</style>
